<template lang="html">
    <div>
        <table class="table accounts has-mobile-cards" v-if="client.ad_accounts.length > 0">
            <thead>
                <tr>
                    <th>Ad Account</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="account in client.ad_accounts">
                    <td class="vendor" data-label="Vendor">
                        <a @click="showAccountData(account)" v-text="accountDisplayLabel(account)"></a>
                        <i class="fa fa-cog fa-spin fa-1x fa-fw text-muted" v-if="isImporting(account.account_id)"></i>
                    </td>
                    <td class="status" data-label="Status">
                        <select class="form-control" name="status" v-model="account.status" v-on:change="updateStatus(account)">
                            <option value="ENABLED">Active</option>
                            <option value="PAUSED">Paused</option>
                        </select>
                    </td>
                    <td class="trash">
                        <button class="btn btn-danger-outline btn-sm" v-show="isAdmin" @click="showDeleteConfirmation(account)">
                            <span class="fa fa-trash-o"></span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-else>No Ad Accounts</p>
        <div class="modal fade" id="modal-delete-account" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Delete Account?
                        </h4>
                    </div>
                    <div class="modal-body">
                        Are you 100% sure that you would like to delete this account and all associated metrics?
                    </div>
                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="deleteAdAccount" :class="{'btn-loading': loading}" :disabled="loading">Yes, I am 100% sure</button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Nope</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            'activeAccount': {},
            loading: false
        }
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
            'importing': 'importing'
        }),
    },

    methods: {

        accountDisplayLabel(account) {
            if (!account.account_label) {
                return account.vendor;
            }
            return  `${account.vendor} (${account.account_label})`;
        },

        isImporting(id) {
            return this.importing.indexOf(id) != -1;
        },

        showAccountData(account) {
            history.pushState(null, null, `#/clients/${this.client.slug}/ad-accounts/${account.account_id}`);
            this.$store.dispatch('client/showAccountDetails', {
                account: account
            });
            Bus.$emit('load-campaign-list');
            Bus.$emit('load-conversion-list');
        },

        showDeleteConfirmation(account) {
            this.activeAccount = account;
            $('#modal-delete-account').modal('show');
        },

        deleteAdAccount() {
            let account = this.activeAccount;
            let client = this.client;
            this.loading = true;

            this.$store.dispatch('client/deleteAdAccount', {
                account: account
            }).then(response => {
                Bus.$emit('show-success-alert', response.message);
                this.loading = false;
            })
            .catch(response => {
                Bus.$emit('show-error-alert', response.data.message);
                this.loading = false;
            });
            $('#modal-delete-account').modal('hide');
        },

        updateStatus(account) {
            this.$store.dispatch('client/updateAccountStatus', {
                account: account
            }).then(response => {
                Bus.$emit('show-success-alert', response.message);
            })
            .catch(response => {
                Bus.$emit('show-error-alert', response.data.message);
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/AdAccountList.vue